import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

import { AllTimeDateRangePicker } from './all_time_date_range_picker';
import { trackAnalyticsClick } from 'js/analytics/metrics/analyticsTracking';

export const AllTimeDateRangePickerContainer = withRouter(
  class extends React.Component {
    static propTypes = {
      location: PropTypes.object.isRequired,
    };

    getStateFromStore = () => {
      return {
        displayedDates:
          Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates,
      };
    };

    componentDidMount() {
      this.unsubscribe = Aedu.ReduxStore.subscribe(
        function () {
          this.setState(this.getStateFromStore());
        }.bind(this),
      );
    }

    componentWillUnmount() {
      this.unsubscribe();
    }

    urlForParams = (params) => {
      const urlWithoutQueryParams =
        location.origin + location.pathname + location.hash;
      return $a.build_url(urlWithoutQueryParams, _.pairs(params));
    };

    previousMonth = () => {
      trackAnalyticsClick('analytics-date-range', { range: 'prev_month' });
      window.location = this.urlForParams({
        start: moment(this.state.displayedDates.start)
          .subtract(30, 'days')
          .format(),
        finish: moment(this.state.displayedDates.finish)
          .subtract(30, 'days')
          .format(),
      });
    };

    nextMonth = () => {
      trackAnalyticsClick('analytics-date-range', { range: 'next_month' });
      window.location = this.urlForParams({
        start: moment(this.state.displayedDates.start).add(30, 'days').format(),
        finish: moment(this.state.displayedDates.finish)
          .add(30, 'days')
          .format(),
      });
    };

    isDisabled = () =>
      this.props.location.pathname === '/activity/impact/12month';

    state = this.getStateFromStore();

    render() {
      return (
        <AllTimeDateRangePicker
          displayedDates={this.state.displayedDates}
          clickPrevious={this.previousMonth}
          clickNext={this.nextMonth}
          isDisabled={this.isDisabled()}
        />
      );
    }
  },
);
